// Recursively removes keys ending in `_tmp` from an object or array.
export function cleanupTmpFields(data) {
  if (Array.isArray(data)) {
    return data.map(cleanupTmpFields)
  }
  if (data !== null && typeof data === "object") {
    const keys = Object.keys(data)
    if (keys.length === 0) return data // Preserve objects with no keys (e.g., Date, File)
    return keys.reduce((acc, key) => {
      if (key.endsWith("_tmp")) {
        return acc
      }
      acc[key] = cleanupTmpFields(data[key])
      return acc
    }, {})
  }
  return data
}